// extracted by mini-css-extract-plugin
module.exports = {"list":"TdList_list__3XKJu","header":"TdList_header__2iQoa","plus":"TdList_plus__3D9m7"};